import BodyTitle from '@firsttable/web-components/atoms/BodyTitle';
import React from 'react';
import PropTypes from 'prop-types';
import { TextAlignProps } from 'styled-system';

type BlogCategoriesProps = {
  categories?: any[];
  textAlign?: TextAlignProps['textAlign'] | '';
};

const blogCategoriesDefaultCategories: any[] = [];
const BlogCategories = ({
  categories = blogCategoriesDefaultCategories,
  textAlign = '',
}: BlogCategoriesProps) => (
  <>
    {categories && categories.length > 0 && (
      <BodyTitle
        as="h5"
        size="xs"
        mt={10}
        mb={10}
        textAlign={textAlign === '' ? undefined : textAlign}
        style={{ textTransform: 'uppercase' }}
        color="grayscale.600">
        {categories.map((category: any) => category.title).join(', ')}
      </BodyTitle>
    )}
  </>
);

BlogCategories.propTypes = {
  categories: PropTypes.array,
  textAlign: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
};

export default BlogCategories;
